import { memo } from 'react';

import { useImageError } from '../../hooks/useImageError';

import Image from '@shared/Image';

import * as styles from './styles.module.scss';

const CardLogo = ({ logoImg, logoTxtFallback }: { logoImg: string; logoTxtFallback: string }) => {
  const { handleError, imgExists: logoImgExists } = useImageError();

  return logoImgExists ? (
    <Image src={`${logoImg}`} onError={handleError} className={styles.logo} />
  ) : (
    <div className={styles.logoTxtFallback}>{logoTxtFallback}</div>
  );
};
export default memo(CardLogo);
